/**
 * Card Clearance Discount Display
 *
 * Re-applies the promotional clearance sale display on product cards after
 * theme.js's swatch handler overwrites the price markup. Source of truth is
 * the collection metafield `discount.percent` (integer), computed server-side
 * by price.liquid / product-badge.liquid / product-card-grid.liquid.
 *
 * The .price element carries data-clearance-percent="<percent>" (set by
 * price.liquid) for eligible products. This script reads that percent and
 * re-applies the crossed-out original price + calculated discounted price
 * after any swatch click or the auto-triggered swatch click on page load.
 *
 * The .product-item element also carries data-clearance-percent for the
 * standalone product-card-grid.liquid layout, and data-clearance-conflict
 * if a product is mistakenly in multiple clearance collections (logged to console).
 */
(function () {
    'use strict';

    // Master switch — set by global-script-2.liquid from settings.show_clearance_sale
    var showClearanceSale = (window.themeSettings && window.themeSettings.showClearanceSale !== false);

    if (!showClearanceSale) return;

    function readClearancePercent(productItem) {
        // Prefer the .price element's attribute (set by price.liquid)
        var priceEl = productItem.querySelector('.price[data-clearance-percent]');
        if (priceEl) {
            var p = Number(priceEl.getAttribute('data-clearance-percent'));
            if (p) return p;
        }
        // Fallback to the product-item attribute (set by product-card-grid.liquid)
        var itemPercent = productItem.getAttribute('data-clearance-percent');
        if (itemPercent) {
            var n = Number(itemPercent);
            if (n) return n;
        }
        return 0;
    }

    function applyDiscountPrice(productItem) {
        var percent = readClearancePercent(productItem);
        if (!percent) return;

        var json = productItem.getAttribute('data-json-product');
        if (!json) return;

        var data;
        try { data = JSON.parse(json); } catch (e) { return; }

        var activeSwatch = productItem.querySelector('.swatch-label.is-active');
        var variantId = activeSwatch ? activeSwatch.getAttribute('data-variant-id') : null;

        var selectedVariant = null;
        if (variantId) {
            for (var i = 0; i < data.variants.length; i++) {
                if (String(data.variants[i].id) === String(variantId)) {
                    selectedVariant = data.variants[i];
                    break;
                }
            }
        }
        if (!selectedVariant) {
            selectedVariant = data.variants[0];
        }
        if (!selectedVariant) return;

        var originalPrice = selectedVariant.price;
        var discountedPrice = Math.round(originalPrice * (1 - percent / 100));

        // Update the standard .price block (layouts 01-08 via price.liquid)
        var priceEl = productItem.querySelector('.price[data-clearance-percent]');
        if (priceEl) {
            priceEl.classList.add('price--on-sale');

            var regularEl = priceEl.querySelector('.price__sale .price-item--regular');
            var saleEl = priceEl.querySelector('.price__sale .price-item--sale');
            var labelEl = priceEl.querySelector('.price__label_sale .label_sale');

            if (regularEl) regularEl.innerHTML = Shopify.formatMoney(originalPrice, window.money_format);
            if (saleEl) saleEl.innerHTML = Shopify.formatMoney(discountedPrice, window.money_format);
            if (labelEl) labelEl.innerHTML = '(-' + percent + '%)';
        }

        // Update the standalone product-card-grid.liquid layout
        var gridPriceItem = productItem.querySelector('.card-price .price-item');
        if (gridPriceItem && productItem.getAttribute('data-clearance-percent')) {
            var badge = gridPriceItem.querySelector('.badge.sale-badge');
            if (badge) badge.textContent = '-' + percent + '%';
            var struck = gridPriceItem.querySelector('s');
            if (struck) struck.innerHTML = Shopify.formatMoney(originalPrice, window.money_format);
            // Update the discounted price text node (last text child after the <s> element)
            var nodes = gridPriceItem.childNodes;
            for (var k = 0; k < nodes.length; k++) {
                var node = nodes[k];
                if (node.nodeType === 3 && node.textContent.trim() !== '') {
                    node.textContent = ' ' + Shopify.formatMoney(discountedPrice, window.money_format) + ' ';
                }
            }
        }
    }

    function applyAll() {
        var items = document.querySelectorAll('.product-item');
        for (var i = 0; i < items.length; i++) {
            applyDiscountPrice(items[i]);
        }
    }

    function reportConflicts() {
        var conflicts = document.querySelectorAll('.product-item[data-clearance-conflict="true"], .price[data-clearance-conflict="true"]');
        if (conflicts.length) {
            console.warn('[Clearance] ' + conflicts.length + ' product(s) found in multiple clearance collections with discount.percent metafield. The highest percentage is being used. Please remove the product from all but one clearance collection.');
        }
    }

    // Re-apply after every swatch click (delegated, fires after theme.js handler)
    document.addEventListener('click', function (event) {
        var target = event.target.closest ? event.target.closest('.card .swatch-label') : null;
        if (!target) return;
        var productItem = target.closest('.product-item');
        if (!productItem) return;
        // Defer to next tick so theme.js's handler runs first
        setTimeout(function () { applyDiscountPrice(productItem); }, 0);
    }, true);

    // Re-apply on initial load (after theme.js auto-triggers active swatch)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(applyAll, 0);
            setTimeout(reportConflicts, 100);
        });
    } else {
        setTimeout(applyAll, 0);
        setTimeout(reportConflicts, 100);
    }

    // Re-apply after AJAX section renders (collection filters, load-more, etc.)
    document.addEventListener('DOMContentLoaded', function () {
        // Watch for new product items being injected
        if (typeof MutationObserver !== 'undefined') {
            var observer = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var nodes = mutations[i].addedNodes;
                    for (var j = 0; j < nodes.length; j++) {
                        if (nodes[j].querySelector && nodes[j].querySelector('.product-item[data-clearance-percent]:not([data-clearance-percent="0"])')) {
                            setTimeout(applyAll, 0);
                            return;
                        }
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    });
})();

/* Mobile Menu — SALE badge injector removed per request.
   Previously injected green "SALE" badges next to specific menu items
   (abayas, everyday essentials, etc.) in both desktop and mobile navigation.
   The "Clearance Sale" menu item still appears in red via the sale_item_1
   theme setting (menu-sale CSS class), which is unaffected. */